import { UUID_REGEX } from "@bindery/shared/auth/authConstants";
import {
  BOOKMARK_CODE_PATTERN,
  normalizeBookmarkCode,
} from "@bindery/shared/contracts/study";
import * as z from "zod";
import { ORIENTATION_API_PREFIX } from "./errors";

export const BOOKMARK_PATH = `${ORIENTATION_API_PREFIX}/bookmark`;

// The session names the reader; the code only has to be theirs.
export const linkBookmarkRequestSchema = z.strictObject({
  sessionId: z.string().regex(UUID_REGEX),
  bookmarkCode: z
    .string()
    .max(32)
    .overwrite(normalizeBookmarkCode)
    .regex(BOOKMARK_CODE_PATTERN),
});
export type LinkBookmarkRequest = z.input<typeof linkBookmarkRequestSchema>;

export const linkBookmarkResponseSchema = z.object({
  status: z.literal("assigned"),
});
export type LinkBookmarkResponse = z.infer<typeof linkBookmarkResponseSchema>;
